export default "__VITE_ASSET__$f$omj1J__"